<template>
  <div class="printcontent">
    <div class="printbox" ref="templatePrintBox">
      <div class="print">
        <div
          class="listdome"
          v-for="(item, index) in printboxcode"
          :key="index"
        >
          <div class="print_cont">
            <div class="up">
              <div class="ev-code">
                {{ item.serial_number }}&nbsp;
                <span v-if="item.provider" class="pro-tag">
                  {{ item.provider }}
                </span>
                <span class="full_station_name">{{
                  item.full_station_name
                }}</span>
              </div>
              <div v-if="item.is_qp == 1" class="qp-tag">R4 &nbsp;企拍</div>
              <div v-else class="qp-tag">R4</div>
              <div class="erwei">
                <img
                  :src="item.qrcode"
                  style="width:100%;height:100%;"
                  alt=""
                />
              </div>
              <div class="xiang-code">
                箱码: <span style="font-size: 16px;">{{ item.box_num }}</span>
              </div>
              <div class="dan-code">
                单号:
                <span style="font-size: 16px;">{{ item.main_number }}</span>
              </div>
              <div class="bian-code">
                编号:
                <span style="font-size: 16px;">{{ item.supplier_code }}</span>
              </div>
              <div class="cstm-name" v-if="item.is_qp == 1">
                客户姓名:{{ item.cstm_name }}
              </div>
              <!-- 非企拍订单，展示收件人姓名 -->
              <!-- <div class="cstm-name" v-else>收件姓名:{{ item.cstm_name }}</div> -->
              <div class="qp-address" v-if="item.is_qp == 1">
                企拍地址:{{
                  item.logistics_proxy.transportInfo.province +
                    item.logistics_proxy.transportInfo.city +
                    item.logistics_proxy.transportInfo.region +
                    item.logistics_proxy.transportInfo.town
                }}
              </div>
              <div class="other-code" v-if="isJgj">
                三方编码:{{ item.self_code }}
              </div>
              <div class="ts-code" v-if="isZhifaOrFactory">
                快递单号:{{ item.courier_number }}
              </div>
              <div class="collect_location zp_order" v-if="item.is_qp == 0">
                {{ item.collect_location }}
              </div>
            </div>
            <div class="down">
              <div class="table">
                <div class="tr flexcenter">
                  <div class="td1">收货方:{{ item.recipient }}</div>
                  <div class="td1">联系方式:{{ item.mobile }}</div>
                </div>
                <div class="tr">
                  <div class="td2 address-gc">
                    <div>
                      <span>收货地址:</span>
                      <span>{{ item.address }}</span>
                    </div>
                    <span v-if="Number(item.order_type) == 2" class="gc-tag"
                      >谷仓</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="last-station-name"
              v-if="
                item.last_station_name && item.last_station_name.length <= 7
              "
            >
              {{ item.last_station_name }}
            </div>
            <div
              class="last-station-name small"
              v-if="item.last_station_name && item.last_station_name.length > 7"
            >
              {{ item.last_station_name }}
            </div>

            <div
              class="collect_location"
              v-if="item.collect_location && item.is_qp == 1"
            >
              {{ item.collect_location }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "jr-qrcode";
import print from "@/utils/mixins/print";
export default {
  props: {
    boxcode: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  mixins: [print],
  data() {
    return {
      isZhifaOrFactory:
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2",
      isJgj: localStorage.getItem("is_jgj") === "1", //紧固件显示
      orcode: "",
      printboxcode: []
      // boxcode: [
      //   {
      //     address: '青浦区新协路1189号',
      //     box_num: 'RBAP19082353730001-001',
      //     courier_number: '',
      //     file_name: '测试店铺箱码0823-0001-R019082349903001-1（4）',
      //     main_number: 'R019082349903001',
      //     mobile: '上海地推仓',
      //     print_model: 'HM-A300',
      //     print_type: 'ApBoxInfoModel',
      //     recipient: '上海地推仓',
      //     serial_number: '0823-0001',
      //     supplier_code: 'SU4470000'
      //   },
      // ]
    };
  },
  watch: {
    printboxcode: {
      handler: function(val) {
        let boxcode = val;
        for (let n of boxcode) {
          n.qrcode = this.bindQRCode(n.box_num);
        }
        // console.log(this.printboxcode);
        this.printboxcode = boxcode;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    myPrint(val = []) {
      let boxcode = val;
      for (let n of boxcode) {
        n.qrcode = this.bindQRCode(n.box_num);
      }
      this.printboxcode = boxcode;
      // console.log("boxcode:", boxcode);
      setTimeout(() => {
        this.browser_print("templatePrintBox");
      }, 500);
    },
    bindQRCode: function(text) {
      let qrcode = QRCode.getQrBase64(text, {
        padding: 0,
        width: 110,
        height: 110
      });
      return qrcode;
    }
  }
};
</script>
<style scoped lang="scss">
.printcontent .printbtnbox {
  position: fixed;
  left: 800px;
  bottom: 100px;
}
.printbox {
  width: 400px;
  margin: 0;
  padding: 0;
}
.print {
  width: 400px;
  box-sizing: border-box;
}
.printbtn {
  position: fixed;
  bottom: 10px;
  left: 50%;
  padding: 0 20px;
  line-height: 36px;
  background: #fc5d1e;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.print .listdome {
  width: 420px;
  height: 250px;
  background: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-top: 8px;
  overflow: hidden;
  box-sizing: border-box;
}
.print .listdome .print_cont {
  border: 1px solid #333;
  color: #333;
  font-size: 12px;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  position: relative;
  box-sizing: border-box;
}
.qp-tag {
  color: red;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  font-weight: 900;
}
.pro-tag {
  color: red;
}
.print_cont .up {
  height: 70%;
  width: 100%;
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
}
.print_cont .up .ev-code {
  font-size: 24px;
  font-weight: 900;
  line-height: 40px;
  // padding-left: 10px;
  box-sizing: border-box;
}
.print_cont .up .erwei {
  position: absolute;
  left: 20px;
  top: 40px;
  width: 110px;
  height: 110px;
  background: #333;
}
.print_cont .up .xiang-code,
.print_cont .up .ts-code,
.print_cont .up .dan-code,
.print_cont .up .bian-code,
.print_cont .up .other-code,
.print_cont .up .cstm-name,
.print_cont .up .qp-address {
  position: absolute;
  left: 140px;
  top: 40px;
  width: 250px;
  // word-break: break-all;
  font-size: 14px;
  font-weight: 600;
}

.print_cont .up .xiang-code {
  width: 260px;
}
.print_cont .up .dan-code {
  top: 60px;
}
.print_cont .up .bian-code {
  top: 80px;
}
// 企拍 样式位置待定
.print_cont .up .cstm-name {
  top: 100;
}
.print_cont .up .qp-address {
  top: 120px;
}
.print_cont .up .other-code {
  top: 100;
}
.print_cont .up .ts-code {
  top: 120px;
}
.print_cont .down {
  padding: 0 10px;
  height: 28%;
  box-sizing: border-box;
}
.down .table {
  border: 1px solid #333;
  border-right: none;
  font-size: 12px;
  color: #333;
  box-sizing: border-box;
}
.down .table .td1 {
  width: 50%;
  border-right: 1px solid #333;
  border-bottom: 1px solid #333;
  padding: 5px;
  height: 30px;
  box-sizing: border-box;
}
.down .table .td2 {
  display: flex;
  align-items: center;
  padding: 2px 5px 2px 5px;
  box-sizing: border-box;
  height: 35px;
  word-break: break-all;
  word-wrap: break-word;
  border-right: 1px solid #333;
}
.flexcenter {
  display: flex;
}
.address-gc {
  display: flex;
  justify-content: space-between;
  .gc-tag {
    margin-left: 30px;
    font-size: 22px;
    font-weight: 700;
  }
}

.full_station_name {
  font-size: 12px;
  font-weight: normal;
}
.last-station-name {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 6px;
  width: 100%;
  // border: 1px solid red;
  font-size: 50px;
  font-weight: bold;
  color: rgba($color: #000000, $alpha: 1);
  // text-align: right;
  line-height: 1;
  &.small {
    font-size: 32px;
  }
}
.collect_location {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px;
  width: 100%;
  // border: 1px solid red;
  font-size: 50px;
  font-weight: bold;
  color: rgba($color: #000000, $alpha: 1);
  text-align: right;
  line-height: 1;
  &.zp_order {
    left: 140px;
    font-size: 40px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/print/boxcode.vue